module.exports = __webpack_public_path__ + "static/media/thorn.ad980568.png";